import { render } from "./ManagerNotes.vue?vue&type=template&id=85f018b0&scoped=true"
import script from "./ManagerNotes.vue?vue&type=script&lang=js"
export * from "./ManagerNotes.vue?vue&type=script&lang=js"

import "./ManagerNotes.vue?vue&type=style&index=0&id=85f018b0&scoped=true&lang=css"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f018b0"]])

export default __exports__